import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type EditingSectionKey = 'reservationInfo' | 'memo' | 'sales' | 'discount'

type EditingSections = Record<EditingSectionKey, boolean>

type EditingSectionState = {
  editingSections: EditingSections
}

const initialState: EditingSectionState = {
  editingSections: {
    reservationInfo: false,
    memo: false,
    sales: false,
    discount: false,
  },
}

export const editingSectionSlice = createSlice({
  name: 'editingSection',
  initialState,
  reducers: {
    setEditingSection(state, action: PayloadAction<{ key: EditingSectionKey; value: boolean }>) {
      state.editingSections[action.payload.key] = action.payload.value
    },
    resetEditingSections: () => initialState,
  },
})

export const editingSectionActions = editingSectionSlice.actions
export const editingSectionReducer = editingSectionSlice.reducer
